import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "./LoginSlice";
import websiteReducer from "./WebsiteSlice";

const store = configureStore({
  reducer: {
    loginReducer: loginReducer,
    website: websiteReducer,
  },
});

export default store;
